// ─── Mini-Store Global con Caché TTL e Invalidación Reactiva ─────────
import { getClientes, getVehiculos, getMecanicos, getOrdenes } from './api.js';

// Caché en memoria
const cache = {
  clientes: { data: null, timestamp: 0 },
  vehiculos: { data: null, timestamp: 0 },
  mecanicos: { data: null, timestamp: 0 },
  ordenes:   { data: null, timestamp: 0 },
};

// Evita disparar varias peticiones iguales cuando dos módulos se inicializan
// al mismo tiempo antes de que la primera respuesta llegue al caché.
const pending = {
  clientes: null,
  vehiculos: null,
  mecanicos: null,
};

// Tiempo de vida predeterminado: 60 segundos
const DEFAULT_TTL_MS = 60 * 1000;

export const store = {
  /**
   * Obtiene la lista de clientes (usa caché si sigue fresca).
   * @param {boolean} forceRefresh - Forzar petición al servidor
   */
  async getClientes(forceRefresh = false) {
    const now = Date.now();
    if (!forceRefresh && cache.clientes.data && (now - cache.clientes.timestamp < DEFAULT_TTL_MS)) {
      return cache.clientes.data;
    }
    if (!forceRefresh && pending.clientes) return pending.clientes;
    pending.clientes = (async () => {
      const res = await getClientes();
      const data = Array.isArray(res) ? res : (res?.data || []);
      cache.clientes = { data, timestamp: Date.now() };
      return data;
    })();
    try { return await pending.clientes; }
    finally { pending.clientes = null; }
  },

  /**
   * Obtiene la lista de vehículos (usa caché si sigue fresca).
   */
  async getVehiculos(forceRefresh = false) {
    const now = Date.now();
    if (!forceRefresh && cache.vehiculos.data && (now - cache.vehiculos.timestamp < DEFAULT_TTL_MS)) {
      return cache.vehiculos.data;
    }
    if (!forceRefresh && pending.vehiculos) return pending.vehiculos;
    pending.vehiculos = (async () => {
      const res = await getVehiculos();
      const data = Array.isArray(res) ? res : (res?.data || []);
      cache.vehiculos = { data, timestamp: Date.now() };
      return data;
    })();
    try { return await pending.vehiculos; }
    finally { pending.vehiculos = null; }
  },

  /**
   * Obtiene la lista de mecánicos (usa caché si sigue fresca).
   */
  async getMecanicos(forceRefresh = false) {
    const now = Date.now();
    if (!forceRefresh && cache.mecanicos.data && (now - cache.mecanicos.timestamp < DEFAULT_TTL_MS)) {
      return cache.mecanicos.data;
    }
    if (!forceRefresh && pending.mecanicos) return pending.mecanicos;
    pending.mecanicos = (async () => {
      const res = await getMecanicos();
      const data = Array.isArray(res) ? res : (res?.data || []);
      cache.mecanicos = { data, timestamp: Date.now() };
      return data;
    })();
    try { return await pending.mecanicos; }
    finally { pending.mecanicos = null; }
  },


  /**
   * Invalida una o todas las claves del caché.
   * @param {'clientes'|'vehiculos'|'mecanicos'|'ordenes'|'all'} key
   */
  invalidate(key = 'all') {
    if (key === 'all') {
      Object.keys(cache).forEach(k => {
        cache[k].data = null;
        cache[k].timestamp = 0;
      });
    } else if (cache[key]) {
      cache[key].data = null;
      cache[key].timestamp = 0;
    }
  }
};
